import { useMsal } from "@azure/msal-react";
import { removeCookie } from "typescript-cookie";
import { useDispatch } from "react-redux";
import { outUser } from "../../redux/slices/auth.slice";
import { IconButton } from "@mui/material";
import { Iconify } from "../../common/iconify";

export const SignOutButton = ({ color = 'black' }) => {
    const { instance } = useMsal();
    const dispatch = useDispatch();

    const handleLogout = (logoutType) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            logout();
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    const logout = () => {
        dispatch(outUser());
        removeCookie('tokenEspolAds');
    };

    
    return (
        <IconButton onClick={() => handleLogout("redirect")}>
            <Iconify icon='streamline:logout-1-solid' width={40} color={color} />
        </IconButton>
    )
}